<div id="ht">
    <div id="main-cnt">
        <ion-content>

            <img class="main-logo svg-white" src="./assets/imgs/logo-blu.svg">

            <amplify-authenticator >
            </amplify-authenticator>


            <!--<amplify-authenticator>
              <ng-template
                      amplifySlot="authenticated"
                      let-user="user"
                      let-signOut="signOut"
              >
                <h1>Welcome {{ user.username }}!</h1>
                <button (click)="signOut()">Sign Out</button>
              </ng-template>
            </amplify-authenticator>-->
        </ion-content>
    </div>
</div>
